import React from 'react';
import { useSpring, animated } from 'react-spring';

import Graphic from '../../../assets/images/graphics/graphic2/proxy-illustratie.svg';

export default function Graphic2({ children }) {
    return (
        <div className="graphic-container">
            <div className="graphic">
                <img className="graphic__man-in-window" src={Graphic} alt="man in window on laptop" />
            </div>
        </div>
    );
}
